import axios from 'axios'
import { api } from '@/global'
import { authHeader } from '@/services/auth-header'


function auth(data){
    return axios.post( api.auth, data )    
}

function checkToken(data){
    return axios.post( api.checkToken, data, {
        headers: authHeader()
    })    
}

function recoverPassword(data){
    return axios.post( api.public + 'request-password-reset', data, {
        headers: authHeader()
    }) 
}

function checkPassToken(data){
    return axios.post( api.public + 'check-password-reset-key', data, {
        headers: authHeader()
    }) 
}

function chagePassword(data){
    return axios.post( api.public + 'reset-password', data, {
        headers: authHeader()
    }) 
}

function register(){
    console.log('criar conta')
}

export {
    auth,
    recoverPassword,
    chagePassword,
    register,
    checkToken,
    checkPassToken
}